import { Injectable } from '@angular/core';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { HttpClient } from '@angular/common/http';
import { Petition, LifeInsurrance } from '../interfaces/interfaces.index';
import { messageValidation } from '../interfaces/messageValidation.interface';
import { LifeInsurance } from '../interfaces/policy-holder.interface';
const URL = `${URL_SERVICIOS}LifeInsurance`;


@Injectable({
  providedIn: 'root'
})
export class SeguroVidaService {

  constructor(private http: HttpClient) { }

  setLifeInsuranceStore = (data: LifeInsurrance) => sessionStorage.setItem('Seguro de vida', JSON.stringify(data));

  createLifeInsurrance = (data: LifeInsurrance) => this.http.post<Petition>(URL, JSON.stringify(data), HTTP_OPTIONS);

  saveLifeInsurrance = (cotizacion: LifeInsurance)  =>
    this.http.post<messageValidation>(`${URL}/SaveLifeInsurance`, JSON.stringify(cotizacion), HTTP_OPTIONS);

  createLifeInsurrancePdf = (petitionId: number, version: boolean) =>
    this.http.post<messageValidation>(`${URL}/CreateLifeInsurance?petitionId=${petitionId}&version=${version}`, HTTP_OPTIONS);

  getLifeInsuranceStore = () => {
    if (sessionStorage.getItem('Seguro de vida')){
      return JSON.parse(sessionStorage.getItem('Seguro de vida'));
    }
  }

  deleteLifeInsurranceStore = () => sessionStorage.removeItem('Seguro de vida');

  getLifeInsurranceByPetitionId = (petitionId: number) => this.http.get<LifeInsurrance>(`${URL}/LifeInsuranceByPetition/${petitionId}`, HTTP_OPTIONS);

  getCounterproposalCallsByPetition = (petitionId: number) => this.http.get<boolean>(`${URL}/CounterproposalCallsByPetition/${petitionId}`, HTTP_OPTIONS);

}
